import React, { FC, useRef, useState } from 'react';

import { FormControl, TextControl } from '@clatter/ui';
import { useMountedEffect } from '@clatter/platform';
import { FolderManagerDialogStateEditedItem, FolderManagerFormErrors } from '../../../interfaces';

interface FolderManagerAddFolderFormProps {
  editedItem: FolderManagerDialogStateEditedItem | null;
  errors: FolderManagerFormErrors | null;
  onChange: (data: string) => void;
  isLoading: boolean;
}

export const FolderManagerAddFolderForm: FC<FolderManagerAddFolderFormProps> = ({
  editedItem,
  onChange,
  errors,
  isLoading,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputNameValue, setInputNameValue] = useState<string>('');

  const [error, setError] = useState<{ message: string } | null>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (error) {
      setError(null);
    }

    if (!event.target.value?.trim() && !error) {
      setError({ message: 'Name is required' });
    }

    setInputNameValue(event.target.value);
    onChange(event.target.value);
  };

  useMountedEffect(() => {
    if (editedItem) {
      setInputNameValue(editedItem?.name || '');
    }
  }, [editedItem?.id]);

  //region EFFECTS
  useMountedEffect(() => {
    if (errors?.['name']) {
      setError(errors['name']);
    }
  }, [errors]);
  //endregion

  return (
    <>
      {/*@ts-ignore*/}
      <FormControl error={error}>
        <TextControl
          //@ts-ignore
          name="name"
          value={inputNameValue}
          onChange={handleInputChange}
          disabled={isLoading}
          placeholder="Enter name"
          ref={inputRef}
          enableFocus
        />
      </FormControl>
    </>
  );
};
